/* Pikamon header — Booster Drop megamenu interactions */
(function () {
  'use strict';

  function init() {
    var header = document.querySelector('[data-pk-header]');
    if (!header) return;

    // ---------- Mobile drawer ----------
    var drawer    = document.getElementById('PkDrawer');
    var openBtn   = header.querySelector('[data-pk-drawer-open]');
    var closeEls  = drawer ? drawer.querySelectorAll('[data-pk-drawer-close]') : [];

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      // force reflow then add open class to play transition
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      // wait for transition before hiding
      setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 350);
    }
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    closeEls.forEach(function (el) { el.addEventListener('click', closeDrawer); });

    // Drawer accordion
    if (drawer) {
      drawer.querySelectorAll('[data-pk-drawer-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          // close siblings for "single-open" accordion behavior
          drawer.querySelectorAll('[data-pk-drawer-toggle][aria-expanded="true"]').forEach(function (other) {
            if (other !== btn) other.setAttribute('aria-expanded', 'false');
          });
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    }

    // ---------- Desktop megamenu (hover-driven, click always navigates) ----------
    // One central state machine so traveling from nav-link → panel → link doesn't
    // close the active panel. Listeners are bound on both the nav-item AND its
    // child panel so leaving one to enter the other doesn't flap the open state.
    var items = [];
    header.querySelectorAll('.pk-hdr__nav-item').forEach(function (item) {
      var panel = item.querySelector('.pk-mm');
      if (!panel) return;
      item.classList.add('has-mega');
      items.push(item);
      item.dataset.pkMmRef = items.length - 1;
    });

    var openItem = null;
    var closeTimer = null;
    var OPEN_DELAY = 0;
    var CLOSE_DELAY = 140;

    function setOpen(item) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openItem && openItem !== item) {
        openItem.classList.remove('is-open');
        var prevLink = openItem.querySelector('.pk-hdr__nav-link');
        if (prevLink) prevLink.setAttribute('aria-expanded', 'false');
      }
      openItem = item;
      item.classList.add('is-open');
      var link = item.querySelector('.pk-hdr__nav-link');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose(item) {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (openItem === item) {
          item.classList.remove('is-open');
          var link = item.querySelector('.pk-hdr__nav-link');
          if (link) link.setAttribute('aria-expanded', 'false');
          openItem = null;
        }
        closeTimer = null;
      }, CLOSE_DELAY);
    }

    function closeAll() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      items.forEach(function (i) {
        i.classList.remove('is-open');
        var l = i.querySelector('.pk-hdr__nav-link');
        if (l) l.setAttribute('aria-expanded', 'false');
      });
      openItem = null;
    }

    items.forEach(function (item) {
      var panel = item.querySelector('.pk-mm');

      item.addEventListener('mouseenter', function () { setOpen(item); });
      item.addEventListener('mouseleave', function (e) {
        // moving to the panel (descendant) doesn't fire mouseleave; this only
        // fires when the cursor exits both the nav-item and its panel
        if (panel && panel.contains(e.relatedTarget)) return;
        scheduleClose(item);
      });

      // Also bind on the panel itself so re-entering after a flap keeps it open
      panel.addEventListener('mouseenter', function () { setOpen(item); });
      panel.addEventListener('mouseleave', function (e) {
        if (item.contains(e.relatedTarget)) return;
        scheduleClose(item);
      });

      item.addEventListener('focusin', function () { setOpen(item); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) scheduleClose(item);
      });
    });

    // Click outside any open megamenu closes it
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAll();
    });

    // Close all megamenus on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAll();
        closeSearch();
        if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      }
    });

    // ---------- Search overlay ----------
    var searchOverlay = document.querySelector('[data-pk-search-overlay]');
    var searchOpenBtn = header.querySelector('[data-pk-search-open]');
    var searchCloseBtn = searchOverlay ? searchOverlay.querySelector('[data-pk-search-close]') : null;
    var searchInput = searchOverlay ? searchOverlay.querySelector('[data-pk-search-input]') : null;

    function openSearch() {
      if (!searchOverlay) return;
      searchOverlay.hidden = false;
      void searchOverlay.offsetWidth;
      document.body.style.overflow = 'hidden';
      if (searchInput) setTimeout(function () { searchInput.focus(); }, 50);
    }
    function closeSearch() {
      if (!searchOverlay || searchOverlay.hidden) return;
      searchOverlay.hidden = true;
      document.body.style.overflow = '';
    }
    if (searchOpenBtn) searchOpenBtn.addEventListener('click', openSearch);
    if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
    if (searchOverlay) {
      searchOverlay.addEventListener('click', function (e) {
        if (e.target === searchOverlay) closeSearch();
      });
    }

    // ---------- Locale / currency auto-submit ----------
    document.querySelectorAll('[data-pk-auto-submit]').forEach(function (el) {
      el.addEventListener('change', function () {
        var form = el.closest('form');
        if (form) form.submit();
      });
    });

    // ---------- Quick cart drawer ----------
    var quickcart = document.getElementById('PkQuickCart');
    var quickcartBody = quickcart ? quickcart.querySelector('[data-pk-quickcart-body]') : null;
    var quickcartOpenBtns = document.querySelectorAll('[data-pk-quickcart-open]');

    function moneyFormat(cents) {
      var formatString = (window.Shopify && Shopify.money_format) || '${{amount}}';
      var n = (cents / 100);
      var formatted = n.toFixed(2);
      return formatString.replace('{{amount}}', formatted)
                         .replace('{{amount_no_decimals}}', Math.round(n).toString())
                         .replace('{{amount_with_comma_separator}}', formatted.replace('.', ','))
                         .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(n).toString());
    }

    function openQuickcart() {
      if (!quickcart) return;
      refreshQuickcart(true);
      quickcart.hidden = false;
      void quickcart.offsetWidth;
      quickcart.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      quickcartOpenBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }
    function closeQuickcart() {
      if (!quickcart) return;
      quickcart.classList.remove('is-open');
      document.body.style.overflow = '';
      quickcartOpenBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () {
        if (!quickcart.classList.contains('is-open')) quickcart.hidden = true;
      }, 350);
    }

    function renderQuickcart(cart) {
      if (!quickcart || !quickcartBody) return;
      var headerCount = header.querySelector('[data-pk-cart-count]');
      if (headerCount) headerCount.textContent = cart.item_count;

      if (cart.item_count === 0) {
        quickcartBody.innerHTML = '<div class="pk-quickcart__empty"><p>Your cart is currently empty.</p>' +
          '<a href="/" class="pk-quickcart__empty-cta" data-pk-quickcart-close>Continue shopping →</a></div>';
        var foot = quickcart.querySelector('[data-pk-quickcart-foot]');
        if (foot) foot.remove();
        bindQuickcartHandlers();
        return;
      }

      var html = '<ul class="pk-quickcart__list">';
      cart.items.forEach(function (item) {
        var img = item.featured_image && item.featured_image.url
          ? '<img src="' + item.featured_image.url.replace(/(\.[a-z]+)$/, '_200x$1') + '" class="pk-quickcart__img" alt="" loading="lazy">'
          : '';
        var variantLine = item.product_has_only_default_variant
          ? ''
          : '<div class="pk-quickcart__variant">' + escapeHtml(item.variant_title || '') + '</div>';
        html += '<li class="pk-quickcart__item" data-pk-quickcart-item data-key="' + escapeAttr(item.key) + '">' +
          '<a href="' + escapeAttr(item.url) + '" class="pk-quickcart__thumb">' + img + '</a>' +
          '<div class="pk-quickcart__meta">' +
            '<a href="' + escapeAttr(item.url) + '" class="pk-quickcart__name">' + escapeHtml(item.product_title) + '</a>' +
            variantLine +
            '<div class="pk-quickcart__row">' +
              '<div class="pk-quickcart__qty">' +
                '<button type="button" class="pk-quickcart__qty-btn" data-pk-quickcart-decrement aria-label="Decrease">−</button>' +
                '<span class="pk-quickcart__qty-value" data-pk-quickcart-qty>' + item.quantity + '</span>' +
                '<button type="button" class="pk-quickcart__qty-btn" data-pk-quickcart-increment aria-label="Increase">+</button>' +
              '</div>' +
              '<div class="pk-quickcart__price">' + moneyFormat(item.final_line_price) + '</div>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="pk-quickcart__remove" data-pk-quickcart-remove aria-label="Remove">×</button>' +
        '</li>';
      });
      html += '</ul>';
      quickcartBody.innerHTML = html;

      // (re)render footer if missing
      var foot = quickcart.querySelector('[data-pk-quickcart-foot]');
      if (!foot) {
        foot = document.createElement('footer');
        foot.className = 'pk-quickcart__foot';
        foot.setAttribute('data-pk-quickcart-foot', '');
        foot.innerHTML =
          '<div class="pk-quickcart__subtotal">' +
            '<span class="pk-quickcart__subtotal-label">Subtotal</span>' +
            '<span class="pk-quickcart__subtotal-amount" data-pk-quickcart-subtotal></span>' +
          '</div>' +
          '<form action="/cart" method="post" novalidate>' +
            '<button type="submit" name="checkout" class="pk-quickcart__checkout">Checkout</button>' +
          '</form>' +
          '<a href="/cart" class="pk-quickcart__viewcart">View full cart →</a>';
        quickcart.querySelector('.pk-quickcart__panel').appendChild(foot);
      }
      var sub = foot.querySelector('[data-pk-quickcart-subtotal]');
      if (sub) sub.textContent = moneyFormat(cart.total_price);
      bindQuickcartHandlers();
    }

    function bindQuickcartHandlers() {
      if (!quickcart) return;
      quickcart.querySelectorAll('[data-pk-quickcart-close]').forEach(function (el) {
        el.addEventListener('click', closeQuickcart);
      });
      quickcart.querySelectorAll('[data-pk-quickcart-item]').forEach(function (item) {
        var key = item.getAttribute('data-key');
        var qtyEl = item.querySelector('[data-pk-quickcart-qty]');
        var dec = item.querySelector('[data-pk-quickcart-decrement]');
        var inc = item.querySelector('[data-pk-quickcart-increment]');
        var rem = item.querySelector('[data-pk-quickcart-remove]');
        if (dec) dec.addEventListener('click', function () {
          changeQty(key, Math.max(0, Number(qtyEl.textContent) - 1));
        });
        if (inc) inc.addEventListener('click', function () {
          changeQty(key, Number(qtyEl.textContent) + 1);
        });
        if (rem) rem.addEventListener('click', function () { changeQty(key, 0); });
      });
    }

    function changeQty(key, quantity) {
      if (!quickcartBody) return;
      quickcartBody.classList.add('is-loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderQuickcart(cart);
        quickcartBody.classList.remove('is-loading');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () { quickcartBody.classList.remove('is-loading'); });
    }

    function refreshQuickcart(reveal) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderQuickcart(cart);
          var headerCount = header.querySelector('[data-pk-cart-count]');
          if (headerCount) headerCount.textContent = cart.item_count;
          if (reveal !== true) {
            var pill = header.querySelector('.pk-hdr__cart');
            if (pill && cart.item_count > 0) {
              pill.classList.add('has-items');
              pill.style.animation = 'none';
              void pill.offsetWidth;
              pill.style.animation = '';
            }
          }
        })
        .catch(function () {});
    }

    // Quickcart drawer reverted — cart pill navigates straight to /cart now.
    // The drawer markup + functions stay in the file so any external triggers still
    // work, but we no longer intercept the cart-pill click. No auto-open on add.

    // Helpers
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function escapeAttr(s) { return escapeHtml(s); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-pk-header]')) init();
  });
})();
